const hobbies = [
  {
    name: 'Rock Climbing',
    description: 'Rock climbing and bouldering are my favourite sports. They combine strength training and problem solving. They are also full body workouts.',
    img: '/img/hobbies.jpg'
  },
  {
    name: 'Gaming',
    description: `I've grown up with games and perhaps even got addicted to them. They provide intense stimulation quickly. I feel like I learn things and receive immediate feedback. I enjoy games on the PC and occasionally on the tabletop. Mobile games are too accessible to be healthy for me. My current obsessions are Hearthstone, Magic Arena and Warhammer 2 Total War.`,
    img: '/img/gaming.jpg'
  },
  {
    name: 'Psychology',
    description: 'I started to studying how people think when I was doing derivative trading. I wanted to know how people tick and how we can circumvent the natural cognitive biases. I also wanted to know how people act in groups. Market trends could be approximated to be large quantities of people acting in groups. It has since become an interest that is still relevant today.',
    img: '/img/morgan-housel-bY5OUwKx3XU-unsplash.jpg'
  },
  {
    name: 'Reading',
    description: 'I enjoy reading. I read widely for knowledge and pleasure. Some examples include politics, social issues, management, problem solving, product design and philosophy.',
    img: '/img/joel-muniz-XqXJJhK-c08-unsplash.jpg'
  }
]

export default hobbies;
